<template>
  <div class="pravo-sirsi__search">
    <ValidationObserver v-slot="{ handleSubmit, failed }" tag="div">
      <div class="pravo-sirsi__search__text">Join a game with a code</div>
      <div class="pravo-sirsi__search__area">
        <div class="pravo-sirsi__search__area__input">
          <ValidationProvider rules="required" v-slot="{ failed }">
            <input
              type="text"
              class="pravo-sirsi__search__area__input__input"
              placeholder="Type your code here"
              :class="{ error: failed }"
              v-model="accessCode"
              maxlength="5"/>
          </ValidationProvider>
        </div>
        <div class="pravo-sirsi__search__area__button">
          <button
            class="pravo-sirsi__search__area__button__button button"
            :disabled="failed"
            @click="handleSubmit(join)">
            Join with a code
          </button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      accessCode: "",
    };
  },
  methods: {
    async join() {
      if (await this.$store.dispatch('join', {code: this.accessCode})) {
        this.$router.push("/team");
      } else {
        this.$toast.error(`Invalid game code.`);
      }
    },
  },
};
</script>
